import { Mail } from "lucide-react";
import { useState } from "react";
import { db } from "../db.ts";
import { Button, Input } from "./ui/index.ts";

export const Auth = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [sentCode, setSentCode] = useState(false);

  const handleSendCode = async () => {
    setLoading(true);
    try {
      if (!email) {
        setMessage("Please enter an email");
        setLoading(false);
        return;
      }
      await db.auth.sendMagicCode({ email });
      setSentCode(true);
      setMessage("Check your email for the code");
    } catch (error) {
      console.error("Auth error:", error);
      setMessage(
        error instanceof Error ? error.message : "Error sending code",
      );
    }
    setLoading(false);
  };

  const handleVerifyCode = async () => {
    setLoading(true);
    try {
      if (!code) {
        setMessage("Please enter the code");
        setLoading(false);
        return;
      }
      await db.auth.signInWithMagicCode({ email, code });
      setMessage("Signed in successfully!");
    } catch (error) {
      console.error("Verification error:", error);
      setMessage(
        error instanceof Error ? error.message : "Invalid code",
      );
    }
    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-[#1a1a1a] to-black">
      <div className="w-full max-w-md px-4">
        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 shadow-2xl">
          <div className="flex flex-col items-center mb-6">
            <img
              src="/logo.jpg"
              alt="Agent FOMO"
              className="h-16 w-16 rounded-2xl object-cover shadow-lg shadow-purple-500/20 mb-4"
            />
            <h1 className="text-3xl font-black tracking-tight text-white text-center">
              AGENT{" "}
              <span className="bg-gradient-to-r from-purple-400 via-pink-500 to-rose-400 bg-clip-text text-transparent">
                FOMO
              </span>
            </h1>
          </div>
          <p className="text-gray-400 text-center mb-8">
            Discover events that match your vibe
          </p>

          <div className="space-y-4">
            <Input
              size="lg"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={sentCode}
              icon={<Mail size={20} />}
            />

            {sentCode && (
              <Input
                size="lg"
                type="text"
                placeholder="Enter code from email"
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            )}

            <Button
              size="lg"
              variant="primary"
              onClick={sentCode ? handleVerifyCode : handleSendCode}
              disabled={!email || (sentCode && !code)}
              loading={loading}
              className="w-full"
            >
              {sentCode ? "Verify Code" : "Send Code"}
            </Button>

            {message && (
              <p className="text-center text-sm text-gray-400 mt-4">
                {message}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
